import { Button, View, Text } from "react-native";
import { style_templates } from "../config_variables/styles";
import Icon2 from "react-native-vector-icons/FontAwesome";
import { variables } from "../config_variables/variables";
import getIconColor from "../utils/getIconColor";

const iconSizeLotListCard = 20
const Timeline = (props) => {

console.log('props.dates: ' + JSON.stringify(props.dates))
console.log('props.type: ' + props.type)
const construction_dates_null = props.type === "construction" ?  props.dates.reduce((ret_val, o) => o.date!= "" ? ret_val && false : ret_val && true, true) : true
console.log('construction_dates_null: ' + construction_dates_null)

  return (
<View style={style_templates.lot_details_card_template}>
      

      { props.type === "status" && props.dates.length > 0 && (
      // { props.type === "status" && (
            <>

      <View style={{flex: 1, height: 2, backgroundColor: 'black'}} />
      
      <View style={style_templates.milestone_container}>
            
            <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('date',props.dates[0].date)} />
            <Text style={style_templates.stage_name_text}> Reserved </Text>
            <Text style={style_templates.milestone_dates}> {props.dates[0].date}</Text>
      </View>
      
      {/* <View style={{flex: 1, marginTop:15, marginBottom: 15, width: 100, height: 12, backgroundColor: 'black'}} /> */}
      <View style={{ marginBottom: 15}} > <Icon2 name="sort-desc" size={30} color={getIconColor('date',props.dates[0].date)} /></View>

      <View style={style_templates.milestone_container}>
            <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('date',props.dates[1].date)} />
            <Text style={style_templates.stage_name_text}> Contracted </Text>
            <Text style={style_templates.milestone_dates}> {props.dates[1].date}</Text>
      </View>

      
      {/* <View style={{flex: 1, marginTop:15, marginBottom: 15, width: 100, height: 12, backgroundColor: 'black'}} /> */}
      <View style={{ marginBottom: 15}} > <Icon2 name="sort-desc" size={30} color={getIconColor('date',props.dates[0].date)} /></View>

      
      <View style={style_templates.milestone_container}>
            <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('date',props.dates[2].date)} />
            <Text style={style_templates.stage_name_text}> Sold</Text>
            <Text style={style_templates.milestone_dates}>{props.dates[2].date}</Text>
      </View>

      {/* <View style={{flex: 1, height: 2, backgroundColor: 'black'}} /> */}
      {/* <View style={{flex: 1, marginTop:15, marginBottom: 15, width: 100, height: 12, backgroundColor: 'black'}} /> */}
      <View style={{ marginBottom: 15}} > <Icon2 name="sort-desc" size={30} color={getIconColor('date',props.dates[0].date)} /></View>
      
      <View style={style_templates.milestone_container}>
            <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('date',props.dates[3].date)} />
            <Text style={style_templates.stage_name_text}> Land Settled </Text>
            <Text style={style_templates.milestone_dates}>{props.dates[3].date}</Text>
      </View>

      {/* <View style={{flex: 1, height: 2, backgroundColor: 'black'}} /> */}
      {/* <View style={{flex: 1, marginTop:15, marginBottom: 15, width: 100, height: 12, backgroundColor: 'black'}} /> */}
      <View style={{ marginBottom: 15}} > <Icon2 name="sort-desc" size={30} color={getIconColor('date',props.dates[0].date)} /></View>

      <View style={style_templates.milestone_container}>
            <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('date',props.dates[4].date)} />
            <Text style={style_templates.stage_name_text}> Build Settled </Text>
            <Text style={style_templates.milestone_dates}>{props.dates[4].date}</Text>
      </View>

      {/* <View style={{flex: 1, height: 2, backgroundColor: 'black'}} /> */}
      </>
      )}


     { props.type === "construction" &&  props.dates.length > 0 && (
            <>

      <View style={{flex: 1, height: 2, backgroundColor: 'black'}} />
      
      <View>
            <View style={style_templates.milestone_container}>
                  <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('date',props.dates[0].date)} />
                  <Text style={style_templates.stage_name_text}> Slab </Text>
                  <Text style={style_templates.milestone_dates}> {props.dates[0].date}</Text>
          </View>
      </View>
      
      {/* <View style={{flex: 1, height: 10, backgroundColor: 'black'}} /> */}
      {/* <View style={{flex: 1, marginTop:15, marginBottom: 15, width: 100, height: 12, backgroundColor: 'black'}} /> */}
      <View style={{ marginBottom: 15}} > <Icon2 name="sort-desc" size={30} color={getIconColor('date',props.dates[0].date)} /></View>

      
      <View style={style_templates.milestone_container}>
            <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('date',props.dates[1].date)} />
            <Text style={style_templates.stage_name_text}> Frame</Text>
            <Text style={style_templates.milestone_dates}>{props.dates[1].date}</Text>
      </View>
      
      {/* <View style={{flex: 1, height: 2, backgroundColor: 'black'}} /> */}
      {/* <View style={{flex: 1, marginTop:15, marginBottom: 15, width: 100, height: 12, backgroundColor: 'black'}} /> */}
      <View style={{ marginBottom: 15}} > <Icon2 name="sort-desc" size={30} color={getIconColor('date',props.dates[0].date)} /></View>

      
      <View style={style_templates.milestone_container}>
            <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('date',props.dates[2].date)} />
            <Text style={style_templates.stage_name_text}> Lock Up</Text>
            <Text style={style_templates.milestone_dates}>{props.dates[2].date}</Text>
      </View>

      {/* <View style={{flex: 1, height: 2, backgroundColor: 'black'}} /> */}
      {/* <View style={{flex: 1, marginTop:15, marginBottom: 15, width: 100, height: 12, backgroundColor: 'black'}} /> */}
      <View style={{ marginBottom: 15}} > <Icon2 name="sort-desc" size={30} color={getIconColor('date',props.dates[0].date)} /></View>

      
      <View style={style_templates.milestone_container}>
            <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('date',props.dates[3].date)} />
            <Text style={style_templates.stage_name_text}> Fix </Text>
            <Text style={style_templates.milestone_dates}>{props.dates[3].date}</Text>
      </View>

      {/* <View style={{flex: 1, height: 2, backgroundColor: 'black'}} /> */}
      {/* <View style={{flex: 1, marginTop:15, marginBottom: 15, width: 100, height: 12, backgroundColor: 'black'}} /> */}
      <View style={{ marginBottom: 15}} > <Icon2 name="sort-desc" size={30} color={getIconColor('date',props.dates[0].date)} /></View>


      <View style={style_templates.milestone_container}>
            <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('date',props.dates[4].date)} />
            <Text style={style_templates.stage_name_text}> Final </Text>
            <Text style={style_templates.milestone_dates}>{props.dates[4].date}</Text>
      </View>

      {/* <View style={{flex: 1, height: 2, backgroundColor: 'black'}} /> */}
      {/* <View style={{flex: 1, marginTop:15, marginBottom: 15, width: 100, height: 12, backgroundColor: 'black'}} /> */}
      <View style={{ marginBottom: 15}} > <Icon2 name="sort-desc" size={30} color={getIconColor('date',props.dates[0].date)} /></View>


            <View style={style_templates.milestone_container}>
            <Icon2 name="check-square-o" size={iconSizeLotListCard} color={getIconColor('date',props.dates[5].date)} />
            <Text style={style_templates.stage_name_text}> Settlement </Text>
            <Text style={style_templates.milestone_dates}>{props.dates[0].date}</Text>
      </View>

      {/* <View style={{flex: 1, height: 2, backgroundColor: 'black'}} /> */}

      </>
      )}



      </View>

  );
};

export default Timeline